import { FormInput } from "../../../FormComponents/Input/Input";
import { useTranslation } from "react-i18next";

const VonEditEmployeeUsernameForm = ({ form, onChange }) => {
    const { t } = useTranslation();
    const { data } = form;

    return <div>
        <fieldset className="d-grid col gap-16 mb-0">
            <legend>{t('vonaccountformcontainer.changeemail')}</legend>
            <FormInput label={t('vonaccountformcontainer.newemail')} value={data.newEmail} onChange={(value) => onChange(form.id, value, 'newEmail')} />
        </fieldset>
    </div>
}

export default VonEditEmployeeUsernameForm;